import axios from "axios";
// const BASE_URL = `${process.env.REACT_APP_API_URL}`;
const SERVERLESS_URL = `${process.env.REACT_APP_AWS_SERVERLESS}`;

export class Iframe {
  private static instance: Iframe;

  public static getInstance(): Iframe {
    if (!Iframe.instance) Iframe.instance = new Iframe();
    return Iframe.instance;
  }
  public async getUnreadyResource(resourceId: string): Promise<any> {
    try {
      const URL = `${SERVERLESS_URL}/partner/iframe/unready?resourceId=${resourceId}`;
      const { data } = await axios.get(URL);
      // console.log("Clip Class function call - Title");
      return data;
    } catch (error: any) {
      console.log({ error });
      console.log(error, { ID: "Iframe Unready Resource GET call exception" });
      return false;
    }
  }
  public async getSpectatedClip(platform: string, mid: string, pid: string): Promise<any> {
    try {
      const URL = `${SERVERLESS_URL}/partner/iframe/spectated?platform=${platform}&mid=${mid}&pid=${pid}`;
      const { data } = await axios.get(URL);
      return data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        // arguably this isn't the best/right way to do this but clip doesn't
        // exist yet but we are returning useable data with the 404 so... 
        return { stillSpectating: true, status: 404, spectatingTime: error?.response?.data };
      } else {
        console.log({ error });
        console.log(error, { ID: "Iframe getSpectatedClip Resource GET call exception" });
        return false;
      }
    }
  }
}
